var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24CoverQuestionMarkCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3A59",
    fillRule: "evenodd",
    d: "M8.5 9.5C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5c0 1.58-1.06 2.903-2.5 3.337V14c0 .553-.447 1-1 1-.553 0-1-.447-1-1v-2c0-.553.447-1 1-1 .827 0 1.5-.673 1.5-1.5S12.827 8 12 8s-1.5.673-1.5 1.5c0 .553-.447 1-1 1-.553 0-1-.447-1-1zM11 17c0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1-.553 0-1-.447-1-1zm1 3c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24CoverQuestionMarkCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon _ 24 _ cover _ question-mark-circle.63940f29.svg";
export { ForwardRef as ReactComponent };